import { render } from "./list.vue?vue&type=template&id=72ad15f9"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=72ad15f9&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__